<h1 mat-dialog-title >
    Choose Login Area
</h1>

<mat-dialog-content appScrolling >
    <div class="box-container mt-4 mb-4">
        <div class="square-box text-center" (click)="onSelect(1)" [ngClass]="{'selected': selectedBox == 1}">
            <div>
                <mat-icon class="mx-auto" style="width: 100px; height: 100px; font-size: 100px; color: #3f51b5;">admin_panel_settings</mat-icon>
                <br>
                <h5 class="mt-1">Admin/Org Users App</h5>
            </div>
        </div>
        <div class="square-box text-center" (click)="onSelect(2)" [ngClass]="{'selected': selectedBox == 2}">
            <div>
                <mat-icon class="mx-auto" style="width: 100px; height: 100px; font-size: 100px; color: #ff9800;">engineering</mat-icon>
                <br>
                <h5 class="mt-1">Engineer's App</h5>
            </div>
        </div>
    </div>
</mat-dialog-content>
